import { render, staticRenderFns } from "./AllCases.vue?vue&type=template&id=416bd8d9&scoped=true&"
import script from "./AllCases.vue?vue&type=script&lang=js&"
export * from "./AllCases.vue?vue&type=script&lang=js&"
import style0 from "./AllCases.vue?vue&type=style&index=0&id=416bd8d9&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "416bd8d9",
  null
  
)

export default component.exports